import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import DissertationsTable from './DissertationsTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import CollapseBlock from '../../../../common/blocks/CollapseBlock/CollapseBlock';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteDissertationMutation,
  useGetDissertationsQuery,
} from '../../../../../redux/services/dissertations';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const DissertationsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { deleteSuccess } = useToastMessages();

  const {
    data: dissertations,
    isLoading,
    refetch,
  } = useGetDissertationsQuery();

  const [deleteDissertation, { isSuccess: isDeleteSuccess }] =
    useDeleteDissertationMutation();

  useEffect(() => {
    document.title = t('Dizertačné práce') + ' - FRI CMS';
  }, []); // Runs on mount

  useEffect(() => {
    if (isDeleteSuccess) {
      deleteSuccess();
      navigate(routes.cmsDissertation);
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Dizertačné práce')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať dizertačnú prácu')}
        createUrl={routes.cmsDissertationCreate}
        permissionsBasic="dissertations"
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <DissertationsTable
            dissertations={dissertations}
            onDelete={(record) => deleteDissertation(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsDissertationEdit}/${record.id}`)
            }
            onCreateClick={() => navigate(routes.cmsDissertationCreate)}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default DissertationsPage;
